export default function progressionDashboardData(data) {
	return {
		level1DoneDate: (data.user.progressionData.level1DoneTimestamp ? new Date(data.user.progressionData.level1DoneTimestamp) : null),
		level2DoneDate: (data.user.progressionData.level2DoneTimestamp ? new Date(data.user.progressionData.level2DoneTimestamp) : null)
	}
}